// 告警websocket封装
import { getSession, setSession } from '@/api/common'
import { Notification, MessageBox } from 'element-ui'
import { connectMessage } from '@/api/websocketAxios'
import store from '../store/index'
import $ from 'jquery'
import router from '@/router'
import i18n from '@/common/i18n'

import Vue from 'vue'
import { errorCollection } from '@/api/dmp/dmpCollection'
/* eslint-disable */
var nowuserId = ''
var lockReconnect = false
var tt

window.CHAT = {
  socket: null,
  keepaliveInterval: null,
  doActionType: -1,
  init: function() {
    // 用window.WebSocket判断浏览器是否支持WebSocket协议
    if (window.WebSocket) {
      // 如果当前的状态已经连接，那就不需要重复初始化websocket
      if (CHAT.socket !== null && CHAT.socket !== undefined && CHAT.socket.readyState === WebSocket.OPEN) {
        return false
      }
      CHAT.socket = new WebSocket(websocketapp.webSocketServerUrl)
      CHAT.socket.onopen = CHAT.wsopen
      CHAT.socket.addEventListener('message', CHAT.wsmessage)
      CHAT.socket.onclose = CHAT.wsclose
      CHAT.socket.onerror = CHAT.wserror
    } else {
      errorCollection('系统异常', '系统异常', {
        status: 200,
        data: { state: -1, msg: '浏览器不支持websocket协议', operationType: 'SYSTEM_ERROR' },
      })
    }
  },

  chat: function(action, helmetId, msg) {
    let wsMsg = new websocketapp.WebSocketMsg(action, helmetId, msg)
    let data = JSON.stringify(wsMsg)
    // 如果当前websocket的状态是已打开，则直接发送， 否则重连
    if (CHAT.socket !== null && CHAT.socket !== undefined && CHAT.socket.readyState === WebSocket.OPEN) {
      CHAT.socket.send(data)
    } else {
      if (action !== websocketapp.KEEPALIVE) {
        errorCollection('系统异常', '系统异常', {
          status: 200,
          data: { state: -1, msg: 'websocket连接错误', operationType: 'SYSTEM_ERROR' },
        })
      }
      // 重连websocket
      CHAT.init()
      setTimeout("CHAT.reChat('" + data + "')", '1000')
    }
  },
  reChat: function(msg) {
    console.log('消息重新发送...')
    if(CHAT.socket !== null && CHAT.socket !== undefined && CHAT.socket.readyState === WebSocket.OPEN){
      CHAT.socket.send(msg)
    }
  },
  wsopen: function() {
    // 定时发送心跳
    if (CHAT.keepaliveInterval != null) {
      clearInterval(CHAT.keepaliveInterval)
    }
    CHAT.keepaliveInterval = setInterval('CHAT.keepalive()', 10000)
  },
  wsmessage: function(e) {
    if (!e.data) {
      errorCollection('系统异常', '系统异常', {
        status: 200,
        data: { state: -1, msg: 'websocket接收消息参数错误', operationType: 'SYSTEM_ERROR' },
      })
      return
    }
    var receiveData = JSON.parse(e.data)
    if (!receiveData || !receiveData.msg) {
      errorCollection('系统异常', '系统异常', {
        status: 200,
        data: { state: -1, msg: 'websocket接收消息参数错误', operationType: 'SYSTEM_ERROR' },
      })
      return
    }
    if (CHAT.socket && CHAT.socket.readyState === WebSocket.OPEN) {
      var receiveMsg = JSON.parse(receiveData.msg)
      var receiveParams = receiveMsg.content.params
    }

    // console.log(receiveData)
    switch (receiveData.action) {
      case -2:
        //注册失败关闭连接
        CHAT.socket.onclose()
        break
      case -1:
        errorCollection('系统异常', '系统异常', {
          status: 200,
          data: { state: -1, msg: 'websocket消息错误', operationType: 'SYSTEM_ERROR' },
        })
        console.log('操作有误')
        break
      case 0:
        errorCollection('系统异常', '系统异常', {
          status: 200,
          data: { state: -1, msg: 'websocket消息错误', operationType: 'SYSTEM_ERROR' },
        })
        console.error('操作有误')
        break
      case 12:
        if (
          !window.location.href.includes('/Intercom') &&
          !window.location.href.includes('/realvideo') &&
          !window.location.href.includes('/externalHistory') &&
          !window.location.href.includes('/monitor') &&
          !window.location.href.includes('/Login')
        ) {
          isWarned(receiveData, receiveParams)
        }
        break
      case 13:
        accetpVoice(receiveData, receiveParams)
        break
      default:
        break
    }
  },
  wsclose: function(e) {
    console.log('wsclose', e)
    clearInterval(CHAT.keepaliveInterval)
    CHAT.socket.close()
    if (e !== undefined && e.code === 1006) {
      // 非正常关闭重连
      CHAT.init()
    }
  },
  wserror: function() {
    console.error('发生错误...')
  },
  keepalive: function(e) {
    CHAT.chat(websocketapp.KEEPALIVE, '', `{\"userId\":'${getSession('tokenMsg')}',\"clientType\":'WEB'}`)
  },
  reconnect: function() {
    if (lockReconnect) {
      return
    }
    lockReconnect = true
    clearTimeout(tt)
    //没连接上会一直重连，设置延迟避免请求过多
    tt = setTimeout(function() {
      CHAT.init()
      lockReconnect = false
    }, 4000)
  },
}

export const createSocket = () => {
  // 创建ws前先请求连接信息
  let params = { type: 'WEB' }
  connectMessage(params).then(res => {
    setSession('tokenMsg', res.msg)
    let webSocketServerUrl = ''
    if (window.location.host.includes('localhost:808')) {
      // 不要在这里直接修改webSocketServerUrl的值！！！
      // 本地环境访问地址，若想切换环境参考 .env 文件中的说明新建一个不会提交的配置文件
      // 不要在这里直接修改webSocketServerUrl的值！！！
      webSocketServerUrl = process.env.VUE_APP_WS_ALERT
    } else if (window.location.protocol === 'http:') {
      webSocketServerUrl = 'ws://' + window.location.host + '/alert/websocket/'
    } else {
      webSocketServerUrl = 'wss://' + window.location.host + '/alert/websocket/'
    }
    window.websocketapp = {
      webSocketServerUrl: webSocketServerUrl + getSession('tokenMsg'),
      /**
       * 和后端的枚举对应
       */
      ERROR: -1, // 错误
      KEEPALIVE: 1, // 客户端保持心跳
      /**
       * 和后端的 WebSocketMsg 消息交互模型对象保持一致
       * @param {Object} action
       * @param {Object} helmetId
       * @param {Object} msg
       */
      WebSocketMsg: function(action, helmetId, msg) {
        this.action = action
        this.helmetId = helmetId
        this.msg = msg
      },
    }
    CHAT.init()
  })
}

function accetpVoice(receiveData, receiveParams) {
  console.log('触发accetpVoice')
  let msg = JSON.parse(receiveData.msg)
  let params = msg.content.params
  store.commit('sendVoice', params)
  // && params.userId !== getSession('userId')
  if (store.state.voiceShow === false && store.state.showTip === false) {
    store.commit('showTip', true)
  }
}

function isWarned(receiveData, receiveParams) {
  let msg = JSON.parse(receiveData.msg)
  let params = msg.content.params
  let alertType = params.alertType
  store.commit('countNum')
  // console.log(params.alertType)
  if (alertType === 'sos') {
    setTimeout(() => {
      let audio = document.getElementById('playAudio')
      audio.play()
    }, 100)
    MessageBox.confirm(
      `<div class="helpAlert">
        <div class="helpTitle">
          <i class="helpIcon"></i>
          <span>${i18n.t('helpMessage')}</span>
        </div>
        <div class="content">
          <span>${params.userName}-${!params.deviceName?params.DeviceName:params.deviceName} ${i18n.t('requestAssistance')}</span>
        </div>
      </div>`,
      {
        confirmButtonText: i18n.t('accept'),
        cancelButtonText: i18n.t('ignore'),
        dangerouslyUseHTMLString: true,
      }
    ).then(() => {
      if (store.state.voiceShow === undefined || store.state.voiceShow === false) {
        if (window.location.href.indexOf('newIndex') !== -1) {
          router.push({ path: '/newIndex/newComunicate', query: { type: 'conversation' } })
          store.commit('currentIndex', 'comunicate')
        } else {
          Vue.prototype.$vAlert({
            title: '语音消息',
            content: '我是内容',
            show: true,
          })
        }
      }
      store.commit('sendSos', params)
    })
  } else {
    // console.log(params,"params")
    let noticeIcon = ''
    let title = ''
    let data = ''
    if (alertType === '跌落告警') {
      noticeIcon = 'noticeIcon_drop'
    } else if (alertType === '撞击告警') {
      noticeIcon = 'noticeIcon_hit'
    } else if (alertType === '故障告警') {
      noticeIcon = 'noticeIcon_fault'
    } else if (alertType === '静止告警') {
      noticeIcon = 'noticeIcon_static'
    } else if (alertType === '脱帽告警') {
      noticeIcon = 'noticeIcon_hat'
    } else if (alertType === '心率过高' || alertType === '心率过低') {
      noticeIcon = 'noticeIcon_heart'
    } else if (alertType === '体温过高' || alertType === '体温过低') {
      noticeIcon = 'noticeIcon_temperat'
    } else if (alertType === '血氧过低') {
      noticeIcon = 'noticeIcon_oxygen'
    } else if (alertType === '进入禁区') {
      noticeIcon = 'noticeIcon_plane'
    }
    if (alertType === '故障告警' || alertType === '静止告警' || alertType === '脱帽告警' || alertType === '进入禁区') {
      title = 'title'
    } else {
      title = 'title-red'
    }
    if (params.data !== undefined) {
      data = `(${params.data})`
    }
    Notification({
      dangerouslyUseHTMLString: true,
      message: `<div class="notice" id="alarmWarm" style="cursor: pointer;z-index: 9999">
      <div class=${noticeIcon}></div>
      <div class="content">
        <div class=${title}>
          <span> ${i18n.t('device')}${!params.deviceName?params.DeviceName:params.deviceName}${i18n.t('alarmAppears')}！</span>
        </div>
        <div class="main">
          <span>${i18n.t('user')}：</span><span>${params.userName}</span>
        </div>
        <div class="main">
          <span>${i18n.t('eventH')}：</span><span>${i18n.t(params.alertType)}${data}</span>
        </div>
        <div class="main"><span>${i18n.t('time')}：</span><span>${params.date}</span></div>
      </div>
    </div>`,
      position: 'bottom-right',
      duration: 5000,
    })
    setTimeout(() => {
      let audio = document.getElementById('playAudio')
      audio.play()
    }, 100)
  }
}

$(document.body).on('click', '#alarmWarm', function() {
  router.push({ path: '/newIndex/newSet/caution' })
  store.commit('currentIndex', 'set')
})
